import { Pipe, PipeTransform } from "@angular/core";
import { OperatorType } from "../enums/operator.type";

/**
 * Display name of a transaction operator.
 * Prefer the backend `operatorName` (MTN, Vodafone, AirtelTigo, bank name):
 *   {{ row.operatorType | operatorType: row.operatorName }}
 * The numeric operatorType is only a fallback for rows that carry no name.
 */
@Pipe({
  name: "operatorType",
})
export class OperatorTypePipe implements PipeTransform {
  transform(value: unknown, operatorName?: string | null): string {
    if (operatorName && operatorName.trim()) {
      return operatorName;
    }
    if (value == undefined) {
      return "None";
    }
    switch (+(value as number) as OperatorType) {
      case OperatorType.Mtn:
        return "MTN";
      case OperatorType.Orange:
        return "Orange";
      case OperatorType.Crypto:
        return "Crypto";
      case OperatorType.M2U:
        return "M2U";
      case OperatorType.MojoPay:
        return "MojoPay";
    }
    return String(value);
  }
}
